import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import router from './router'
import ElementUI from 'element-ui'
import Common from './common.js'
import VueI18n from 'vue-i18n'
import 'echarts-wordcloud'
import axios from 'axios'
import './assets/css/index.css'
import './assets/icon/iconfont.css'
import MyBread from '@/views/templates.vue'

import '../static/themes/default/css/ueditor.css'
import '../static/ueditor.config.js'
import '../static/ueditor.all.min.js'
import '../static/lang/zh-cn/zh-cn.js'
// import '../static/ueditor.parse.min.js'
import '../static/xiumi-ue-dialog-v5.js'
import '../static/xiumi-ue-v5.css'
import './fonts/font.css'
// import Meta from 'vue-meta'
// Vue.use(Meta)
Vue.component('MyBread', MyBread)//全局自定义组件
axios.defaults.timeout = 120000//请求超时5秒
axios.defaults.timeoutErrorMessage = '请求超时...'
axios.defaults.headers.post['Content-Type'] = 'application/json' //设置post请求是的header信息
axios.defaults.withCredentials = true;
//http request 拦截器
axios.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem('Authorization');
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers = {
        Authorization: token,
      }
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  },
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}, headers = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params: params, headers: headers }).then((response) => {
      
      if (response.data.Code == '403') {
        this.Global.request_failure('您的账号在另一台设备登录，如果不是您操作，请修改密码');
        this.$router.push('/login');
        return false;
        } if (response.data.Code == '203') {
          this.Global.request_failure('登录过期!');
          this.$router.push('/login');
        } else {
        resolve(response.data);
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then((response) => {
        if (response.data.Code == '403') {
          this.Global.request_failure('您的账号在另一台设备登录，如果不是您操作，请修改密码');
          this.$router.push('/login');
          return false
        } else if (response.data.Code == '203') { 
          this.Global.request_failure('登录过期!');
          this.$router.push('/login');
        } else {
          resolve(response.data);
        }
      },(err) => {
        reject(err)
      },
    )
  })
}

Vue.use(VueI18n);
const i18n = new VueI18n({
  messages: {    
    ch: require('./assets/languages/chs.json'),
    en: require('./assets/languages/en.json'),
    chs_school: require('./assets/languages/chs_school.json'),
  }
})

Vue.use(ElementUI);
Vue.prototype.Global = Common;
//定义全局变量
Vue.prototype.$Http_Post = post;
Vue.prototype.$Http_Get = get;
// Vue.prototype.$moment = moment
// moment.locale('zh-cn') // 这里是进行了汉化 不写这句默认格式是外国的
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
let startApp = function () {
  axios.get('/config.json').then((res) => {

    axios.defaults.baseURL = process.env.VUE_APP_URL;//修改为获取当前域*
    // axios.defaults.baseURL = 'https://mhec.ucas.ac.cn:8019';//外  
    // axios.defaults.baseURL = 'http://192.168.2.18:8080';//沈
    // axios.defaults.baseURL = 'http://192.168.1.82:8080';//王
    // axios.defaults.baseURL = 'http://192.168.4.6:8040';//余
    // axios.defaults.baseURL = 'http://192.168.1.80:8080';//孙
    // axios.defaults.baseURL = 'http://210.5.159.76:8095';//测试
    
    if (localStorage.getItem('language') == "en") {
      i18n.locale = "en"
    }
    else {
      i18n.locale = "ch"
    } 
    // i18n.locale = res.data.Language == '' ? 'ch' : res.data.Language;
    // localStorage.setItem('language', res.data.Language == '' ? 'ch' : res.data.Language);
    new Vue({
      router,
      i18n,
      store,
      render: (h) => h(App),
    }).$mount('#app')
  })
}

startApp()
const com = Vue.extend({
  template: '<h1>这是一个模板组件</h1>',
})
Vue.component('myView', com)
